/**
 * Refinevoice - Main App Component with Routing
 */

import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { Layout } from './components/Layout';
import { AuthProvider } from './contexts/AuthContext';
import { Account } from './pages/Account';
import { Extension } from './pages/Extension';
import { Home } from './pages/Home';
import { MarkdownPageRender } from './pages/MarkdownPageRender';
import { MinimalWidgetDemo } from './pages/MinimalWidgetDemo';
import { WidgetDemo } from './pages/WidgetDemo';
import Widgets from './pages/Widgets';
import { initNavigationFromURL, useNavigationStore } from './store/useNavigationStore';
import './App.css';

export default function App() {
  const { currentPage } = useNavigationStore();

  // Initialize navigation from URL on mount
  useEffect(() => {
    initNavigationFromURL();
  }, []);

  return (
    <AuthProvider>
      <Layout>
        {currentPage === 'home' && <Home />}
        {currentPage === 'account' && <Account />}
        {currentPage === 'extension' && <Extension />}
        {currentPage === 'widget-react' && <WidgetDemo />}
        {currentPage === 'minimal-demo' && <MinimalWidgetDemo />}
        {currentPage === 'widgets' && <Widgets />}
        {currentPage === 'imprint' && <MarkdownPageRender contentPath="/content/imprint.md" />}
        {currentPage === 'privacy' && <MarkdownPageRender contentPath="/content/privacy.md" />}
      </Layout>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
